import { Component, Host, Prop, State, Watch, h } from '@stencil/core';


@Component({
  tag: 'accordion-section',
  styleUrl: 'accordion-section.scss',
  shadow: false,
})
export class AccordionSection {
  @Prop() heading: string;
  @Prop() content: string;
  @Prop() sections: string;
  @Prop() image: string;
  @Prop() reverse: boolean;

  @State() _sections : any;
  @State() _image: any;

  @Watch('sections')
  watchAllNewsHander(newValue, oldValue) {
    this._sections = JSON.parse(this.sections);
    
  }
  @Watch('image')
  watchImageHandler(newValue, oldValue) {
    this._image = JSON.parse(this.image);
  }
  componentWillLoad() {
    //console.log("sections", this.sections);
    this._image = JSON.parse(this.image);
    this._sections = JSON.parse(this.sections);
    this._sections.forEach(element => {
      element.collapsed = true;
    });
    //console.log("_sections", this._sections);
    console.log("reverse", this.reverse);
  }

  componentDidLoad() {
    

  }

  toggle(evt,idx) {
    console.log("toggle", evt.target.ariaControlsElements);
    //const target = evt.target.getAttribute('aria-controls');
    this._sections = this._sections.map((el,i) => {
      if (idx ==i) {
        console.log("element",el);
        el.collapsed = !el.collapsed;
      } 
      // else {
      //   el.collapsed = true;
      // }
      return el;
    })
    
  }
  

  render() {
    return (
      <Host> 
        <div class={"tw-flex tw-flex-col md:tw-gap-9 " + (this.reverse ? "md:tw-flex-row-reverse" : " md:tw-flex-row")}>
          <div class="tw-flex-auto md:tw-basis-1/2">
            <h2 class="tw-mb-10">{this.heading}</h2>
            {this.content && (
            <p class="section-content">
              {this.content}
            </p>
            )} 
            {this._sections && this._sections.length > 1 && this._sections.map((section, idx) => (
              <div
                class="tw-border-t tw-border-neutral-200">
                <h3 class="mb-0" id="headingOne">
                  <button
                    class="tw-group tw-relative tw-flex tw-w-full tw-items-center tw-border-0 tw-px-0 tw-py-5 tw-text-left tw-text-xl tw-font-semibold tw-text-neutral-800 
                    tw-transition [tw-overflow-anchor:none] hover:tw-z-[2] focus:tw-z-[3] 
                    focus:tw-outline-none"
                    type="button"
                    aria-expanded={section.collapsed ? "false" : "true"}
                    aria-controls={"collapse" + idx}
                    data-index={idx}
                    onClick={(e) => this.toggle(e,idx)}>
                    {section.GroupHeading}
                    <span
                      class={(section.collapsed ? "" : "tw-rotate-180") + " tw-ms-auto tw-h-5 tw-w-5 tw-shrink-0 tw-transition-transform tw-duration-200 tw-ease-in-out [&>svg]:tw-h-6 [&>svg]:tw-w-6"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div
                  id={"collapse" + idx}
                  // class="!visible"
                  class={(section.collapsed ? "tw-hidden" : "") + " collapsable-panel"}
                  data-twe-collapse-item
                  data-twe-collapse-show
                  aria-labelledby="headingOne"
                  data-twe-parent="#accordionExample">
                  <div class="tw-pb-4 tw-pt-0">
                    {section.GroupContent && (
                      <p>{section.GroupContent}</p>
                    )}
                    
                    <ul>
                    {section.Terms.length > 0 && section.Terms.map((term)=> (
                      <li class="tw-flex tw-flex-row tw-content-center tw-items-center tw-px-6 tw-py-2 tw-me-4 tw-mb-2 text-base">
                        <svg class="tw-self-start tw-mt-1 tw-mt-0 tw-mr-1 bi bi-check-lg tw-inline-block " xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                        </svg>
                        <div class="tw-inline-block">{term}</div>
                      </li>
                    ))}
                    </ul>
                  </div>
                </div>
            </div>
            ))}
            {this._sections && this._sections.length == 1 && this._sections.map((section, idx) => (
              <div
                class="tw-border-none tw-border-neutral-200">
                {section.GroupHeading && (
                <h3 class="tw-mb-0" id="headingOne">
                  <span class="text-xl">
                    {section.GroupHeading}
                  </span>
                </h3>
                )}
                <div
                  class=" collapsable-panel"
                  data-twe-collapse-item
                  data-twe-collapse-show
                  aria-labelledby="headingOne"
                  data-twe-parent="#accordionExample">
                  <div class="tw-pb-4 tw-pt-0">
                    {section.GroupContent && (
                      <p>{section.GroupContent}</p>
                    )}
                    
                    <ul>
                    {section.Terms.length > 0 && section.Terms.map((term)=> (
                      <li class="tw-flex tw-flex-row tw-content-center tw-items-center tw-px-6 tw-py-2 tw-me-4 tw-mb-2 text-base">
                      <svg class="tw-self-start tw-mt-1 tw-mt-0 tw-mr-1 bi bi-check-lg tw-inline-block " xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                      </svg>
                      <div class="tw-inline-block">{term}</div>
                    </li>
                    ))}
                    </ul>
                  </div>
                </div>
            </div>
            ))}


            
            

            </div>
            {this._image && (
              <div class="tw-flex-auto tw-basis-1/2">
                
                <img src={this._image.MediaUrl} alt={this._image.AlternativeText.join('')}/>
                
              </div>
            )}

        </div>
      </Host>
    );
  }

}
